import React from "react";
import { Icon } from "@iconify/react";
import { useLandingModals } from "./landingModalContext";

/**
 * Mobile-only floating CTA (nav hides Let's Connect under 640px).
 * Styled in landing.scss — hidden while Bootstrap modals are open.
 */
export default function LandingConnectFab() {
  const { openLetsConnect } = useLandingModals();

  return (
    <button type="button" className="rs-connect-fab" onClick={openLetsConnect}>
      <span className="rs-connect-fab__icon" aria-hidden>
        <Icon icon="solar:chat-round-dots-linear" width={17} height={17} />
      </span>
      <span className="rs-connect-fab__text">Let&apos;s Connect</span>
    </button>
  );
}
